export function StarFillIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M10.548 3.807c.467-1.343 2.367-1.343 2.834 0l1.65 4.748 5.026.103c1.422.029 2.009 1.836.875 2.695l-4.005 3.037 1.455 4.81c.412 1.362-1.125 2.479-2.292 1.666l-4.126-2.87-4.126 2.87c-1.168.813-2.704-.304-2.293-1.665l1.456-4.811-4.006-3.037c-1.133-.86-.546-2.666.876-2.695l5.026-.103 1.65-4.748z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
